import client from './api-client';

export const serviceGetCfgForm = async (query) => {
    try {
        const response = await client.getSelect(`cfg-forms?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetHitos = async (query) => {
    try {
        const response = await client.getSelect(`gestion-implicado/contacto/hitos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}

export const serviceGetImplicados = async(query) => {
    try {
        const response = await client.getImplicado(`caso/implicado/terceros?q=${query}`);      

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error) {
        throw error;
    }
}

export const serviceGetInforme = async(query) => {
    try {
        const response = await client.getDoc(`get-file?q=${query}`);      

        if (response.status === 200 && response.data.code === 1) return response.data
        else throw new Error(response.data.message);
    } 
    catch(error) {
        throw error;
    }
}

export const serviceGetProcesosJudiciales = async (query) => {
    try {
        const response = await client.getSelect(`gestion-implicado/cierre-defensa/proceso-judicial?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetHistoriaGastos = async (query) => {
    try {
        const response = await client.getSelect(`gestion-implicado/gastos/historial?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetDetalles = async(query) => {
    try {
        const response = await client.getSelect(`detalles?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}

export const servicePagosEmitidos = async(query) => {
    try {
        const response = await client.getSelect(`emision-pagos-cia/pagos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}
